module.exports = __webpack_public_path__ + "img/vocabulary-text-contetn-bg.e36118d1.png";